// extracted by mini-css-extract-plugin
module.exports = {"container":"OverThePastYear_container__jYAIV","insightCardsContainer":"OverThePastYear_insightCardsContainer__Jqzmm"};